<template>
  <vs-sidebar v-if="student" click-not-close parent="#correction" :hidden-background="true" class="correction-view-sidebar full-vs-sidebar items-no-padding" v-model="isSidebarActive" position-right>
    <div class="px-0 sm:pb-6 h-full">
      <div class="flex flex-wrap items-center correction-header justify-between md:px-8 px-6 sm:pb-2 sm:pt-2 d-theme-dark-bg">
        <div class="flex items-center">
          <div class="mr-4">
            <feather-icon :icon="$vs.rtl ? 'ArrowRightIcon' : 'ArrowLeftIcon'" @click="$emit('closeSidebar')" class="cursor-pointer" svg-classes="w-6 h-6"></feather-icon>
          </div>
          <div class="mr-1">
            <vs-avatar :src="student.image" size="42px" @click="viewProfile(student.user_id)"></vs-avatar>
          </div>
          <div class="w-full flex items-center">
            <div class="flex flex-col truncate">
              <h5 class="font-bold text-primary cursor-pointer" @click="viewProfile(student.user_id)">{{student.full_name}}</h5>
              <span class="truncate">{{student.id}}</span>
            </div>
          </div>
        </div>
      </div>
      <VuePerfectScrollbar v-if="student.answer"
                           class="scroll-content-area md:px-8 md:pb-8 pt-4 px-6 pb-6"
                           :settings="{ maxScrollbarLength: 60, wheelPropagation: true, }" :key="$vs.rtl">
        <h4 class="mb-2">الإجابة</h4>
        <text-editor-viewer class="mb-4" :data="student.answer.body"/>
        <template v-if="student.answer.file.path">
          <h6 class="mb-2">المرفقات</h6>
          <file class="lg:w-1/2"
                :name="student.answer.file.name"
                :size="student.answer.file.size"
                :path="student.answer.file.path"/>
        </template>
        <vx-divider class="mb-base"/>

        <div class="flex items-center mb-base">
          <span class="font-bold mr-4"> الدرجة </span>
          <div class="flex items-center" :class="[student.answer.mark !== null || student.answer.mark !== '' ? 'border-primary' : 'border-danger', 'px-4 py-2 rounded-full border border-solid border-primary']">
            <span class="font-bold mr-1">{{assignmentMark}} / </span>
            <vs-input-number v-model="student.answer.mark" min="0" :max="assignmentMark" />
          </div>
        </div>

        <div @click="student.answer.teacher_comment = ''"
             v-if="student.answer.teacher_comment === null"
             class="flex items-center mb-4 text-lg text-primary hover:underline cursor-pointer">
          <span>أضف ملاحظة</span>
          <feather-icon icon="MessageCircleIcon" class="ml-2" svg-classes="h-5 w-5" />
        </div>
        <div v-else class="lg:w-1/2 mb-base">
          <div class="flex items-center justify-between mb-2">
            <label>أكتب ملاحظه علي الإجابة</label>
            <vs-button @click="student.answer.teacher_comment = null"
                       color="danger" type="flat" icon="icon-x" icon-pack="feather" radius title="إزالة الملاحظه" />
          </div>
          <textarea-autosize :dir="student.answer.teacher_comment ? 'auto' : 'rtl'"
                             v-model="student.answer.teacher_comment" color="mt-2" />
        </div>

        <div class="clearfix">
          <vs-button class="bg-primary-gradient mt-5 sm:w-64 w-full float-left" icon-after @click="correct">تصحيح</vs-button>
        </div>
      </VuePerfectScrollbar>
      <template v-else>
        <div class="flex flex-col items-center mt-24">
          <feather-icon icon="UserXIcon" class="mb-4 p-8 shadow-md rounded-full" svgClasses="w-16 h-16" />
          <h4 class="py-2 px-4 shadow-md rounded-full">لم يقم الطالب بتسليم الواجب بعد</h4>
        </div>
      </template>
    </div>
  </vs-sidebar>
</template>

<script>
    import assignmentsAPI from '@/api/assignmentsAPI'
    import VuePerfectScrollbar from 'vue-perfect-scrollbar'
    import TextEditorViewer from '@/views/components/TextEditorViewer'

    export default {
        name: 'AssignmentCorrectionView',
        components: { TextEditorViewer, VuePerfectScrollbar },
        props: {
            student: {
                type: Object,
                required: true
            },
            assignmentMark: {
                type: Number,
                required: true
            },
            isSidebarActive: {
                type: Boolean,
                required: true
            },
        },
        methods: {
            correct(){
                let data = {
                    student_id: this.student.id,
                    teacher_comment: this.student.answer.teacher_comment,
                    mark: this.student.answer.mark
                }

                assignmentsAPI.correctAssignment(this.$route.params.assignment_id, data)
                    .then(response => {
                        this.$notifySuccess(response.successMessage)
                        this.$emit('correct')
                        this.$emit('closeSidebar')
                    })
                    .catch(error => this.$notifyError(error.statusMessage))
            },
        },
        mounted() {
            if(this.student.answer && !this.student.answer.mark) this.student.answer.mark = 0
        }
    }
</script>
